<template>
  <div id="notFound">
    <img :src="logoPrimary" class="center-block logo">

    <div class="text-center col-sm-12">
      <h1>You are lost.</h1>
      <h4>This page doesn't exist.</h4>
      <router-link to="/" class="vertical-5p lead">Take me home.</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound',
  data() {
    return {
      logoPrimary: require('@/assets/Kobe Logo Blue.png')
    }
  }
}
</script>

<style>
#notFound {
  padding: 10em;
  color: white;
}

#notFound .logo {
  display: block;
  width: min(260px, 72vw);
  max-width: 260px;
  height: auto;
  margin: 0 auto 24px;
}
</style>



// WEBPACK FOOTER //
// 404.vue?29fcb400